/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type RollbackPromptRequestBody = {
  /**
   * Version number to rollback to
   */
  version: number;
};

export type RollbackPromptRequest = {
  id: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
  requestBody: RollbackPromptRequestBody;
};

/** @internal */
export const RollbackPromptRequestBody$inboundSchema: z.ZodType<
  RollbackPromptRequestBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  version: z.number().int(),
});
/** @internal */
export type RollbackPromptRequestBody$Outbound = {
  version: number;
};

/** @internal */
export const RollbackPromptRequestBody$outboundSchema: z.ZodType<
  RollbackPromptRequestBody$Outbound,
  z.ZodTypeDef,
  RollbackPromptRequestBody
> = z.object({
  version: z.number().int(),
});

export function rollbackPromptRequestBodyToJSON(
  rollbackPromptRequestBody: RollbackPromptRequestBody,
): string {
  return JSON.stringify(
    RollbackPromptRequestBody$outboundSchema.parse(rollbackPromptRequestBody),
  );
}
export function rollbackPromptRequestBodyFromJSON(
  jsonString: string,
): SafeParseResult<RollbackPromptRequestBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => RollbackPromptRequestBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RollbackPromptRequestBody' from JSON`,
  );
}

/** @internal */
export const RollbackPromptRequest$inboundSchema: z.ZodType<
  RollbackPromptRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  id: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
  RequestBody: z.lazy(() => RollbackPromptRequestBody$inboundSchema),
}).transform((v) => {
  return remap$(v, {
    "X-On-Behalf-Of": "xOnBehalfOf",
    "RequestBody": "requestBody",
  });
});
/** @internal */
export type RollbackPromptRequest$Outbound = {
  id: string;
  "X-On-Behalf-Of"?: string | undefined;
  RequestBody: RollbackPromptRequestBody$Outbound;
};

/** @internal */
export const RollbackPromptRequest$outboundSchema: z.ZodType<
  RollbackPromptRequest$Outbound,
  z.ZodTypeDef,
  RollbackPromptRequest
> = z.object({
  id: z.string(),
  xOnBehalfOf: z.string().optional(),
  requestBody: z.lazy(() => RollbackPromptRequestBody$outboundSchema),
}).transform((v) => {
  return remap$(v, {
    xOnBehalfOf: "X-On-Behalf-Of",
    requestBody: "RequestBody",
  });
});

export function rollbackPromptRequestToJSON(
  rollbackPromptRequest: RollbackPromptRequest,
): string {
  return JSON.stringify(
    RollbackPromptRequest$outboundSchema.parse(rollbackPromptRequest),
  );
}
export function rollbackPromptRequestFromJSON(
  jsonString: string,
): SafeParseResult<RollbackPromptRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => RollbackPromptRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RollbackPromptRequest' from JSON`,
  );
}
